import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Badge } from './ui/badge';
import { Search, Users, TrendingUp } from 'lucide-react';

const TestShadcnComponents = () => {
  return (
    <div className="p-6 space-y-6 bg-background">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-foreground mb-2">
          🎉 Tailwind + shadcn/ui + Lucide Setup Complete!
        </h1>
        <p className="text-muted-foreground">
          Testing the new UI framework installation
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Total Users</CardTitle>
            <Users className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">2,350</div>
            <p className="text-xs text-muted-foreground">
              <span className="text-green-600">+180.1% from last month</span>
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Growth Rate</CardTitle>
            <TrendingUp className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">12.5%</div>
            <p className="text-xs text-muted-foreground">
              <span className="text-green-600">+2.1% from last month</span>
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Quick Test</CardTitle>
            <CardDescription>
              Testing various components
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="relative">
              <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
              <Input placeholder="Search..." className="pl-8" />
            </div>
            
            <div className="flex space-x-2">
              <Button size="sm">Primary</Button>
              <Button variant="outline" size="sm">Outline</Button>
              <Button variant="secondary" size="sm">Secondary</Button>
            </div>
            
            <div className="flex space-x-2">
              <Badge>Success</Badge>
              <Badge variant="secondary">Info</Badge>
              <Badge variant="outline">Warning</Badge>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="text-center text-sm text-muted-foreground">
        ✅ All components are working! Ready to redesign your admin interface.
      </div>
    </div>
  );
};

export default TestShadcnComponents;
